import { createReducer } from "@reduxjs/toolkit";
import type { ExternalProviderBatchRequestVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { adminRetrieveExternalProviderBatchRequestList } from "./retrieve-external-provider-batch-request-list";
import type { RetrievalState } from "@redux/state/shared-types";

const initialState: RetrievalState<ExternalProviderBatchRequestVM[]> = {
  fetching: "idle",
  data: [],
};

export const retrieveExternalProviderBatchRequestListReducer = createReducer(initialState, builder => {
  builder.addCase(adminRetrieveExternalProviderBatchRequestList.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(adminRetrieveExternalProviderBatchRequestList.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(adminRetrieveExternalProviderBatchRequestList.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
